export default {
    PleaseEnterSupplierName: "Please Enter Shop Name",
    pleaseSelectMainBusinessCategory: "Please Select Main Business Category",
    pleaseEnterContactName: "Please Enter Contact Name",
    pleaseEnterContactPhoneNumber: "Please Enter Contact Phone Number",
    pleaseEnterDetailedAddress: "Please Enter Detailed Address",
    pleaseSetYourPassword: "Please Set Password",
    pleaseConfirmPassword: "Please Confirm Password",
    NeedProvideBusinessLicense: "(please Provide Business License)",
    pleaseEnterTheNameOfLegalPerson: "Please Enter The Name Of Legal Person",
    pleaseEnterThePhoneNumber: "Please Enter The Phone Number",
    pleaseEnterLegalPersonsIDCard: "Please Enter Legal Persons ID Card",
    pleaseEnterUnifiedSocialCreditCode: "Please Enter Unified Social Credit Code",
    pleaseSelectDate: "Please Select Date",
    MustContainCombinationUppercaseNLowercaseLettersNNumbers: "It must contain upper and lower-case letters and numbers，The length is between 6 and 20 and special characters cannot be used！",
    pleaseEnterTheAdminsPhoneNumber: "Please Enter The Admins Phone Number",
    threeToThirtyCharactersInLength: "Three To Thirty Characters In Length",
    pleaseEnterTheNameOfTheAdmin: "Please Enter The Name Of TheAdmin",
    pleaseEnterThePassword: "Please Enter The Password",
    pleaseEnterAccAndPsw: "Please enter your account number and password",
    pleaseEnterPasswordAgain: "Please Enter Password Again",
    theTwoPasswordsRInconsistent: "The Two Passwords Inconsistent!",
    pleaseEnterTheWarehouseAddress: "Please Enter The Warehouse Address",
    pleaseEnterTheLegalPersonPhoneNumber: "Please Enter The Legal Person Phone Number",
    pleaseEnterTheLegalPersonIDNumber: "Please Enter The Legal Person ID Number",
    pleaseUploadBusinessLicense: "Please Upload Business License",
    pleaseUploadID: "Please Upload ID",
    pleaseFillInTheBusinessPeriod: "Please Fill In The Business Period",
    pleaseFillTheUnifiedScialCreditCode: "Please Fill The Unified Scial Credit Code"
}